import NotFoundPage from './components/NotFoundPage'

export default NotFoundPage
